import React, { useState, useEffect, useCallback } from "react";
import Pagination from "@material-ui/lab/Pagination";
import PaginationItem from "@material-ui/lab/PaginationItem";
import ScreenHeader from '../../components/ScreenHeader';
import { Button } from '@material-ui/core';
import AddIcon from "@material-ui/icons/Add";
import UserItem from './components/UserItem';
import ProfilesService from "../../../../services/ProfilesService";
import { Link, useLocation } from "react-router-dom";
import { calcCountPages, calcOffset } from "../../../../utils/pagination";
import EmptyResult from "../../../components/EmptyResult";
import ModalAddNewUser from "./modals/modalNewUser";
import SearchBox from "../../../components/SearchBox/SearchBox";



function useQuery() {
  return new URLSearchParams(useLocation().search);
}

function UsersScreen(props){
  const usersLoading = Array.from(Array(5).keys());
  const [users, setUsers] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [openModalAddNewUser, setOpenModalAddNewUser] = useState(false);
  const PROFILE = props.profile;
  const PAGINATION_URL = PROFILE === undefined ? "/dashboard/users":`/dashboard/users/${PROFILE}s`;
  const TITLE_MAP = {
    student: "Staff/Students",
    teacher: "Managers/Educators",
    manager: "Admin"
  };

  // pagination
  const location = useLocation();
  let query = useQuery();
  const [countPages, setCountPages] = useState(0);
  const page = parseInt(query.get("page")) || 1;
  const paginationLimit = 15;

  // Get users data
  const fetchUsersData = useCallback(async (value) => {
    setIsLoading(true);
    try {
      const result = await ProfilesService.listProfiles({
        fields: "id,email,first_name,last_name,profile_type,phone,is_active",
        limit: paginationLimit,
        offset: calcOffset(page, paginationLimit)
      }, {
        profile: PROFILE,
        q: value
      });
      setUsers(result.data.results);
      setCountPages(calcCountPages(result, paginationLimit));
      setIsLoading(false);
    } catch (error) {
      setUsers([]);
    }
  }, [page, PROFILE]);

  useEffect(() => {
    // Query Params changued
    fetchUsersData();
  }, [fetchUsersData, location.search]);

  const updateItemsList = () => {
    fetchUsersData();
  };

  const removeUserFromList = userId => {
    fetchUsersData();
    // const newUsers = users.filter((item, index) => item.id !== userId);
    // setUsers(newUsers);
    // setCountPages(calcCountPages(newUsers, paginationLimit));
  };

  return (
    <div id="users-screen" className={`${props.className} dashboard-container`}>
      {/* Header */}
      <ScreenHeader title={`${TITLE_MAP[PROFILE] || 'Users'}`}>
        <Button
          variant="outlined"
          color="primary"
          onClick={() => setOpenModalAddNewUser(true)}
          endIcon={<AddIcon />}
        >
          {" "}
          Add {TITLE_MAP[PROFILE] || 'User'}
        </Button>
        {/* <IconButton color="primary" aria-label="add course" component="span">
          <AddIcon />
        </IconButton> */}
      </ScreenHeader>

      {/* Body */}
      <div className="content">
        <SearchBox fetchData={fetchUsersData} placeholder="Search by first name, last name or mail" />
        {isLoading ? (
            // Generate 5 courses of loading data
            usersLoading.map(i => <UserItem key={i} loading />)
          ) : // Show courses
          users.length > 0 ? (
            users.map(course => (
              <UserItem
                data={course}
                key={course.id}
                profile={PROFILE}
                removeItem={removeUserFromList}
                updateItemsList={updateItemsList}
                openSnack={props.openSnack}
              />
            ))
          ) : (
            // Show Empty courses
            <EmptyResult />
          )}
        
        <Pagination
          page={page}
          count={countPages}
          color="primary"
          size="large"
          renderItem={item => (
            <PaginationItem
              component={Link}
              to={`${PAGINATION_URL}${
                item.page === 1 ? "" : `?page=${item.page}`
              }`}
              {...item}
            />
          )}
        />
      </div>

      <ModalAddNewUser
        open={openModalAddNewUser}
        onClose={() => setOpenModalAddNewUser(false)}
        updateItemsList={updateItemsList}
        profile={PROFILE}
      />
    </div>
  )
}

export default UsersScreen;